export default __webpack_public_path__ + "static/media/3396.b5ee300e.png";